import { Box, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import { Card, CardContent } from "../../../shared/components/ui/Card";
import { useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { useDashboard } from "../context/useDashboard";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: false },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: { stepSize: 10 },
      grid: { color: "#e3e7f0" },
    },
    x: {
      grid: { color: "#e3e7f0" },
    },
  },
};

export const UsersChart = () => {
  const { activeUserGraph, isLoadingActiveUserGraph } = useDashboard();

  useEffect(() => {
    return () => {
      ChartJS.unregister();
    };
  }, []);

  if (isLoadingActiveUserGraph || !activeUserGraph) {
    return (
      <Card sx={{ minHeight: 320 }}>
        <CardContent>
          <Typography variant="subtitle1" fontWeight={600} mb={1}>
            Usuários ativos por mês
          </Typography>
          <Box height={200} display="flex" alignItems="center" justifyContent="center">
            <Typography>Carregando...</Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  const chartData = {
    labels: activeUserGraph.labels,
    datasets: [
      {
        data: activeUserGraph.data,
        borderColor: "#1976d2",
        backgroundColor: "rgba(25, 118, 210, 0.1)",
        fill: true,
        tension: 0.4,
      },
    ],
  };

  return (
    <Card sx={{ minHeight: 320 }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Usuários ativos por mês
        </Typography>
        <Box height={200}>
          <Line data={chartData} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
}; 